import $ from "jquery";

console.log("nac_desktop_b4ba.js running");

$('.nav_desktop_b4ba__dropdown_megas').slideUp(200);

// dropdown-mega
// When hovering on each .main_menu_item
$('.nav_desktop_b4ba__menu .main_menu_item').on('mouseenter', function() {
  var $li = $(this);

  // Remove .active from all .main_menu_item siblings first
  $('.nav_desktop_b4ba__menu .main_menu_item').removeClass('active');

  // Add .active to the hovered one
  $li.addClass('active');

  // Continue with your existing dropdown logic:
  if ($li.attr('data-dropdown-mega') && $li.attr('data-dropdown-mega').length > 0 ) {
    var data_dropdown_mega = $li.attr('data-dropdown-mega');
    if ($('.nav_desktop_b4ba__dropdown_megas [data-dropdown-mega="' + data_dropdown_mega + '"]').length > 0) {
      // Show that dropdown
      $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
      $('.nav_desktop_b4ba__dropdown_megas [data-dropdown-mega="' + data_dropdown_mega + '"]').addClass('show_dropdown_mega');
      $('.nav_desktop_b4ba__dropdown_megas').fadeIn(400);
      $('.bg-overlay').fadeIn(400);
      
      // Apply gradient if data-dropdown-mega == 1132
      if(data_dropdown_mega == 1132){
        $('.applygrad').addClass('mega_gradient');
      } else {
        $('.applygrad').removeClass('mega_gradient');
      }
    } else {
      // If no matching dropdown found
      $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
      $('.temp_light_theme').addClass('theme_dark');
      $('.temp_light_theme').removeClass('temp_light_theme');
      $('.nav_desktop_b4ba__dropdown_megas').slideUp(400);
      $('.bg-overlay').fadeOut(200);
      $('.applygrad').removeClass('mega_gradient');
    }
  }
});

// When leaving the entire nav, remove active from all items
$('.nav_desktop_b4ba').on('mouseleave', function(){
  $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
  $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
  $('.nav_desktop_b4ba__menu .main_menu_item').removeClass('active'); // <--- remove active here
  $('.temp_light_theme').addClass('theme_dark');
  $('.temp_light_theme').removeClass('temp_light_theme');
  $('.nav_desktop_b4ba__dropdown_megas').slideUp(200);
  $('.bg-overlay').fadeOut(200);
});

$(window).scroll(function() {
  if ($( window ).width() < 1024){
    if($(window).scrollTop() > 20) {
          // $('.theme_dark').addClass('temp_light_theme');
          // $('.theme_dark').removeClass('theme_dark');
          $('.nav_desktop_b4ba__dropdown_megas').slideUp(0);
    }else{
      // $('.temp_light_theme').addClass('theme_dark');
      // $('.temp_light_theme').removeClass('temp_light_theme');
    }
  }
});


$(".removeClick").click(function(event){
  event.preventDefault();
});

console.log("fade in active.. " + $('.split_hero').length);
  $('.split_hero').fadeTo( "200" , 1, function() {
  console.log('Animation complete');
});


// spacer size
function setSpacerSize(){
  console.log('setSpacerSize');
  var navHeight = $('.nav_desktop_b4ba').height();
  $('.nav_desktop_b4ba__spacer').css({'height': navHeight + 'px'})
}

setSpacerSize();

$(window).on('resize', function() {
  setSpacerSize();
});

// $(document).ready(function() {
//   var currentUrl = window.location.href;

//   // Remove .active from all main menu items first
//   $('.nav_desktop_b4ba__menu .main_menu_item').removeClass('current');

//   // Loop through each anchor in .main_menu_item
//   $('.nav_desktop_b4ba__menu .main_menu_item a').each(function() {
//     // Compare the anchor's href with the current URL
//     if (this.href === currentUrl) {
//       // Add .active to the parent .main_menu_item
//       $(this).closest('.main_menu_item').addClass('current');
//     }
//   });
// });

jQuery(document).ready(function($){
  var thresholdScroll   = 20; // Must scroll beyond this to ever show the menu
  var scrollUpDistance  = 20; // Must scroll up 20px from maxScrollTop to show the menu
  var scrollDownTrigger = 20; // Must scroll down 20px from the show position to hide the menu

  var menuactive         = false;
  var maxScrollTop       = 0;  // Tracks the highest scroll position reached so far
  var menuShowScrollTop  = 0;  // The scrollTop where menu was shown
  
  $(window).on('scroll', function() {
    var currentScrollTop = $(this).scrollTop();

    // Always track the maximum scroll position reached
    if (currentScrollTop > maxScrollTop) {
      maxScrollTop = currentScrollTop;
    }
    
    // 1) If menu is NOT active, check if user has scrolled up enough to show it
    if (!menuactive) {
      // Condition: user is past the thresholdScroll,
      // AND they've come up from maxScrollTop by at least scrollUpDistance
      if (
        currentScrollTop > thresholdScroll &&
        (maxScrollTop - currentScrollTop) >= scrollUpDistance
      ) {
        // --- Show the menu ---
        var elementHeight = $('.nav_desktop_b4ba').height();
        $('.nav_desktop_b4ba').css('top', -elementHeight);
        $('.nav_desktop_b4ba').animate({ top: '0px' }, 300);
        $('.nav_desktop_b4ba').addClass('fixedmenu');
        
        menuactive        = true;
        menuShowScrollTop = currentScrollTop; // remember where we showed it
      }
    } 
    else {
      // 2) If menu IS active, check if user scrolled down from show position
      if ((currentScrollTop - menuShowScrollTop) >= scrollDownTrigger) {
        // --- Hide the menu ---
        var elementHeight = $('.nav_desktop_b4ba').height();
        $('.nav_desktop_b4ba').animate({ top: -elementHeight }, 300, function(){
          $('.nav_desktop_b4ba').removeClass('fixedmenu');
        });
        
        menuactive = false;
        // Because we just scrolled downward, let's reset maxScrollTop
        maxScrollTop = currentScrollTop;
      }
    }

    // 3) If user is at the very top of the page, remove .fixedmenu
    if (currentScrollTop === 0) {
      $('.nav_desktop_b4ba').removeClass('fixedmenu');
      menuactive         = false;
      // Also reset tracking variables
      maxScrollTop       = 0;
      menuShowScrollTop  = 0;
    }
  });
});









